import uuid from "../../../library/uuid.js";
import global from "../../global.js";
const d3 = global.d3;

//const log = global.log.getLogger("f_mtac.scene.drivers.attachment");

const Attachment = function(group, resource, media) {
    this.data = {
        id: `local-${uuid()}`,
        class: ["node", "attachment", "movable", "removable"],
        storage: "object"
    };
    this.group = group;
    this.node = resource;
    this.resource = resource;
    this.handle = null;
    this.media = media;
    this.figure = null;
    this.eye = null;
    this.position = {
        x: 0,
        y: 0
    };
};
Attachment.prototype.draw = function(x, y) {
    this.group.select(`#${this.data.id}`).remove();
    this.handle = this.group.append("g").attr("class", "handle").attr("id", this.data.id);
    this.handle.on("click", () => d3.event.preventDefault());
    this.node = this.handle
        .append("g").attr("class", this.data.class.join(" "))
        .attr("data-media", this.media.local_id)
        .attr("data-media-type", this.media.media_data.type.split("/")[0])
        .attr("transform", `translate(${x},${y})`);
    this.node.append("g").attr("class", "color");
    this.node.append("g").attr("class", "name");
    this.figure = this.node.append("g").attr("class", "figure");
    this.figure.append(() => this.resource).attr("transform", null);
    this.position.x = x;
    this.position.y = y;
};
Attachment.prototype.replace = function(resource) {
    this.figure.html("");
    this.figure.append(() => resource).attr("transform", null);
    this.resource = resource;
};
Attachment.prototype.center = function() {
    let base_element = this.figure.node();
    let position = this.handle.node().getBBox();
    let {x, y, width, height} = base_element.getBBox();
    let relative_position = {x: position.x + x + width / 2, y: position.y + y + height / 2};
    let element = base_element;
    while(element.parentNode !== null && element.parentNode !== this.handle.node()) {
        let {x, y} = element.parentNode.getBBox();
        relative_position.x -= x;
        relative_position.y -= y;
        element = element.parentNode;
    }
    return relative_position;
};
Attachment.prototype.update = function(x, y) {
    this.node.attr("transform", `translate(${x},${y})`);
    this.position.x = x;
    this.position.y = y;
};
Attachment.prototype.end = function() {
    this.handle.on("click", null);
    return Promise.resolve();
};
Attachment.prototype.is_empty = function() {
    return false;
};
Attachment.prototype.detach = function() {
    this.handle = null;
    this.node = null;
    this.figure = null;
};
Attachment.prototype.export = function() {
    return this.handle;
};

export default Attachment;
